import {FormHelperText, Grid} from '@mui/material';
import {FormikErrors} from 'formik';
import {useCallback, useEffect, useMemo, useState} from "react";
import FormModal from "../components/form/FormModal";
import FormContainer from "../components/form/FormContainer";
import {SimpleSelectFormField} from "../components/form/SimpleSelectFormField";
import {JsonEventInfo} from "../generated-api";
import {OptionValue} from "../model/form";
import {useAppTranslation} from "../services/i18n";
import {useAppDispatch} from "../store";
import {fetchEvents} from "../store/events";
import {getApiResult} from "../helpers/api";

interface FormValues {
    sourceEventId?: number;
}

/** Picks the event to copy from, the previous one is preselected. */
const EventCloneModal = (props: {
    eventId: number,
    title: string,
    info: string,
    onSave: (sourceEventId: number) => Promise<void>,
    onCancel: () => void,
}) => {
    const {eventId, title, info, onSave, onCancel} = props;

    const t = useAppTranslation();
    const dispatch = useAppDispatch();
    const [events, setEvents] = useState<JsonEventInfo[]>();

    useEffect(() => {
        dispatch(fetchEvents({orderCol: 'eventId', orderDir: 'desc'})).then((res) => {
            setEvents((getApiResult<JsonEventInfo[]>(res) || []).filter((e) => e.eventId !== eventId));
        });
    }, [dispatch, eventId]);

    const options = useMemo((): OptionValue[] => (events || [])
        .map((e) => ({value: e.eventId!, label: e.title || ''})), [events]);

    const item = useMemo((): FormValues => ({
        sourceEventId: (events || []).filter((e) => !!e.eventId && e.eventId < eventId)[0]?.eventId,
    }), [events, eventId]);

    const handleValidate = useCallback((values: FormValues) => {
        const errors = {} as FormikErrors<FormValues>;
        if (!values.sourceEventId) {
            errors.sourceEventId = t('Zvolte prosím zdrojovou událost');
        }
        return errors;
    }, [t]);

    const handleSave = useCallback((values: FormValues) => onSave(values.sourceEventId!), [onSave]);

    return <FormModal title={title} onCancel={onCancel}>
        {!!events && <FormContainer item={item} onCancel={onCancel} saveButtonTitle={t('Zkopírovat')}
            validate={handleValidate} onSave={handleSave} children={<>
            <Grid item xs={12}>
                <SimpleSelectFormField name="sourceEventId" label={t('Zdrojová událost')} options={options}/>
            </Grid>
            <Grid item xs={12}>
                <FormHelperText>{info}</FormHelperText>
            </Grid>
        </>}/>}
    </FormModal>;
}

export default EventCloneModal;
